import login from './login';
import authentication from './authentication';
import newPassword from './newPassword';

export default {
  namespaced: true,
  modules: {
    login,
    authentication,
    newPassword
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/security/index.js